import { ArticleItem } from 'types'

const textData: Array<ArticleItem> = [
  {
    text: 'JOGOS DE IMPROVISAÇÃO EM MÚSICA CONTEMPORÂNEA:',
    style: ['title1'],
  },
  {
    text: 'Possibilidades para a iniciação coletiva ao violoncelo',
    style: ['title1'],
  },
  {
    text: 'Autoria: Marta Macedo Brietzke',
    style: ['paragraph', 'margin'],
  },
  {
    text: 'Orientador: Prof. Dr. Fabio Soren Presgrave',
    style: ['paragraph', 'margin'],
  },
  {
    text: 'Coorientador: Prof. Dr. Mário André Wanderley Oliveira',
    style: ['paragraph', 'margin'],
  },
  {
    text: '',
    style: ['space'],
  },
  {
    text:
      'Este trabalho faz parte da minha Dissertação de Mestrado, intitulada “Música contemporânea na iniciação coletiva ao violoncelo:uma pesquisa - ação com jogos de improvisação em três instituições de ensino no estado de São Paulo”, defendida em 12 de dezembro de 2018, pela Universidade de São Paulo, com orientação do Prof. Dr. Fabio Soren Presgrave e coorientação do Prof. Dr. Mário André Wanderley Oliveira.',
    style: ['paragraph', 'italic'],
  },

  {
    text: 'A música contemporânea:',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'O termo música contemporânea, muito utilizado por intérpretes, professores e estudantes de música, carece ainda de uma definição precisa. Uma das problemáticas que envolve o uso desse termo é a ideia que ele se destinaria a definir toda e qualquer música produzida na atualidade. Para nos ajudar a definir o que se chama comumente nos meios acadêmicos de música contemporânea, recorremos as concepções da professora Bernardete Zagonel. A professora esclarece que, em tais meios, o termo é frequentemente utilizado para designar a música europeia de concerto dos séculos XX e XXI, que foi orientada esteticamente pelas profundas mudanças filosóficas, científicas, culturais e tecnológicas que aconteceram nesse período. Quando nos dispomos a ouvir e a apreciar a música contemporânea, precisamos nos despreender de paradigmas antigos e abrir nossas percepções para entender e apreender outras formas de expressão musical. A música contemporânea pode ser definida, então, como a produção musical ligada à música de concerto, vinculada a propostas artísticas formuladas a partir do século XX e marcadas pelas complexidades de diversas referências artísticas, culturais e filosóficas.',
    style: ['paragraph'],
  },
  {
    text:
      'Apesar dessas novas características já estarem consolidadas de diferentes maneiras desde meados do século XX, ainda hoje, com frequência, parte dos músicos profissionais e dos estudantes de música não é familiarizada e, inclusive, não gosta de tocar ou ouvir a música que envolva possibilidades sonoras distintas das consideradas tradicionais (as produzidas nos séculos anteriores). Porém, também desde o século passado diferentes músicos, compositores, educadores e professores de instrumento, buscam incorporar esse repertório e essas possibilidades sonoras às práticas dos estudantes. Como exemplo dessas iniciativas, podemos citar os trabalhos de Béla Bartók e Boris Porena, e também dos brasileiros Heitor Villa-Lobos, Ernest Mahle e Bruno Kiefer.',
    style: ['paragraph'],
  },
  {
    text:
      'A utilização do repertório da música contemporânea nas aulas de instrumento continua sendo reduzida e pouco divulgada. A pouca aceitação desse repertório nas salas de concerto do país pode ainda gerar dúvidas sobre a importância de sua aplicação, sobretudo com os estudantes de nível iniciante. Devemos compreender que a aplicação de propostas ligadas às poéticas da música contemporânea aproxima os estudantes das concepções e do pensamento do seu próprio tempo, principalmente quando essas propostas estão ligadas a atividades de criação, como o que acontece nas práticas de improvisação. Ao utilizarmos o termo “poética” para nos referirmos à música contemporânea, nos aproximamos de uma concepção que vê a música não apenas como linguagem, mas como uma expressão artística fundamentada nas concepções filosóficas, estéticas, históricas, sociais e políticas do seu entorno e, até mesmo, em elementos biográficos dos artistas. Esse termo, utilizado desde a antiguidade pelo filósofo grego Aristóteles para se referir às obras literárias passou a ser adotado na contemporaneidade para se referir à outras manifestações artísticas, como por exemplo, as artes visuais, as artes cênicas e a música, se referindo a tudo aquilo que é produzido fazendo uso deliberado de uma composição estética.',
    style: ['paragraph'],
  },
  {
    text:
      'Através das propostas da música contemporânea que envolvem a improvisação trazermos a criação para dentro das salas de aula de instrumento e aproximamos a arte da vida cotidiana, e a “música-pensamento”, assim como chamou o poeta Augusto de Campos, do dia a dia dos estudantes/intérpretes. Atualmente, a “música-pensamento”, ou a ”música de invenção”, como é algumas vezes chamada, parece estar destinada a uma parcela mínima da população que tem acesso ao ensino musical especializado. Dessa maneira, a abertura às diferentes manifestações musicais, compreendidas como fenômenos socioculturais, parece estar condicionadas a fatores de natureza social e econômica, pouco democráticas e inclusivas. No Brasil, a formação musical nas escolas especializadas, com grande frequência, destina-se quase exclusivamente a investigar e reproduzir repertórios de séculos anteriores aos séculos XX e XXI. Assim, o estudante tende a executar apenas obras do passado. Nas principais salas de concerto brasileiras, o espetáculo musical também parece ser direcionado, quase sempre, à apreciação de caráter histórico, sendo desfavorecida a ideia da arte como agente promotor do pensamento crítico e da reflexão.',
    style: ['paragraph'],
  },
  {
    text:
      'Cabe a nós, professores de música, em conjunto com compositores e pesquisadores da área, ressaltar o valor da música como produto e produtora de experiências e de pensamento. Para tanto, a execução de obras musicais da atualidade, desde o início da formação do estudante/intérprete é essencial para que possamos trazer a “música-pensamento” para dentro da nossa vida diária.',
    style: ['paragraph'],
  },
  {
    text: 'A improvisação:',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'A improvisação é uma prática que se desenvolveu ao longo dos séculos e de diferentes maneiras em muitas culturas, como por exemplo, as culturas indianas, árabes e persas, entre outras. Nas culturas europeias, essa prática era comum até meados do século XIX, quando os papeis do compositor e do intérprete começaram a ser delineados como auto-excludentes. A prática da improvisação continuou sendo abordada, geralmente nos meios da música popular, em estilos como o jazz, o choro, a salsa, nas manifestações artísticas conhecidas como “livre improvisação”, assim como em peças de compositores das poéticas contemporâneas que, algumas vezes, destinam passagens à improvisação dos intérpretes.',
    style: ['paragraph'],
  },
  {
    text:
      'Desde meados do século XX, a prática da improvisação tem se mostrado também uma estratégia pedagógica importante para o ensino de música. Porém, essa prática é pouco aplicada nas aulas de instrumento musical, segundo a pesquisadora Chefa Alonso, com exceção dos países nórdicos. Compreender a importância de atividades ligadas à improvisação e algumas propostas de utilização dessa prática nos auxilia, enquanto professores, a elaborar concepções onde essa se inclua nas atividades planejadas para nossas aulas. Os pesquisadores e educadores musicais enfatizam em seus trabalhos e relatos que, por meio de atividades relacionadas à improvisação, é possível apresentar os conteúdos musicais aos estudantes ao mesmo tempo em que a música se torna um veículo para a expressão de percepções, pensamentos e sentimentos.',
    style: ['paragraph'],
  },
  {
    text:
      'Desde o trabalho do pesquisador Derek Bailey, que data o ano de 1993, a improvisação começou a ser classificada segundo algumas características relativas ao seu idiomatismo. Apesar do uso desses termos ter sido relativizado pelo próprio pesquisador que os definiu, eles ainda são usados amplamente. É chamada de “improvisação idiomática” a que está ligada a um estilo ou “idioma” musical específico e de “improvisação não idiomática” a que não se relaciona com um idioma em particular, mas com o som, com suas possíveis relações e transformações. Dentro das práticas relacionadas como “não idiomáticas” encontra-se também a “improvisação livre”, que abarca uma série de manifestações que se definem como tal. Em comum, essas práticas desenvolvem o foco na performance, que inclui, em maior ou menor grau, uma atuação ativa e criativa em tempo real. Os educadores musicais, na maioria dos casos, abordam em seus processos de ensino e aprendizagem alguns elementos de propostas ligadas à improvisação livre.',
    style: ['paragraph'],
  },
  {
    text:
      'A prática da improvisação livre enquanto objeto artístico surgiu na Alemanha e na Inglaterra na década de sessenta do século XX, por meio da criação de diversos grupos dedicados à essa prática. Em paralelo começou a ser observado pelos educadores musicais que as crianças naturalmente já improvisam livremente e que se essa prática for estimulada, elementos musicais podem ser incorporados às suas vivências e aprendizagem. Os educadores ressaltam alguns dos benefícios da improvisação, entre eles, a aprendizagem de novas formas de relações interpessoais baseadas na igualdade, o aprofundamento da relação com o instrumento, a maior compreensão das composições musicais, a necessidade da resolução de problemas que se apresentam como similares aos da vida cotidiana, o desenvolvimento da criatividade, da autoexpressão, da autoestima e da autonomia.',
    style: ['paragraph'],
  },
  {
    text: 'Os jogos na aprendizagem:',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Educadores e pensadores de diversas áreas vêm desenvolvendo ao longo do tempo, ideias a respeito da aprendizagem por meio dos jogos, porém, os pesquisadores atuais consideram que essas ideias ainda não estão claras para todas as pessoas que trabalham diretamente com a educação. Um dos motivos dessa confusão diz respeito à característica polissêmica da palavra jogo, que pode ser usada para referenciar atividades com significados diversos. O jogo vem sendo estudado como uma parte natural e essencial do ser humano, parte essencial da aprendizagem e da transmissão de conhecimentos e da própria cultura.',
    style: ['paragraph'],
  },
  {
    text:
      'Para os pesquisadores que lidam com a aprendizagem através dos jogos, esses não possuem um “objetivo educacional” determinado, mas consideram que tudo o que aprendemos, aprendemos por intermédio do jogo. Os jogos de improvisação propostos por este trabalho acompanham essa ideia, não possuem como objetivo o desenvolvimento de conteúdos específicos, e sim, são destinados a trabalharem a natureza lúdica inata das crianças e adolescentes.',
    style: ['paragraph'],
  },
  {
    text: 'O ensino coletivo do violoncelo:',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Na nossa prática enquanto professores, muitas vezes, encontramos instituições onde o ensino se dá apenas de maneira individual, ou tutorial, e outras onde o ensino acontece coletivamente. No Brasil, na maioria das vezes, o ensino coletivo acontece em instituições ou ONG’s onde o fluxo de estudantes é constante e é preciso atender a um grande número de estudantes ao mesmo tempo, enquanto nas escolas livres ou conservatórios, o ensino é dirigido a uma única pessoa por vez. Porém, a opção pelo ensino coletivo vai além das restrições econômicas, levando-se em consideração seus objetivos e concepções.',
    style: ['paragraph'],
  },
  {
    text:
      'Estima-se que o ensino de instrumento em grupo, como o denominamos hoje, iniciou ainda no século XIX na Inglaterra e posteriormente nos Estados Unidos. No Brasil, ele começou a ser adotado na década de cinquenta do século XX, sendo que, na década de setenta, um grande movimento surgiu para o ensino coletivo de cordas friccionadas, encabeçado por Alberto Jaffé e Dayse de Luca. A partir da disseminação do ensino coletivo de instrumento, pesquisadores iniciaram a investigação sobre os benefícios de tal modelo de ensino, benefícios que, além de musicais, são de ordem psicológica e social.',
    style: ['paragraph'],
  },
  {
    text:
      'No ensino coletivo, acredita-se que é possível compartilhar conhecimento, espaço, e que a interação e a diferença são partes importantes da aprendizagem. Além desses valores, a prática musical em conjunto proporciona a maior diversificação de conteúdos musicais abordados, pois se incluem algumas variáveis que são impossíveis no ensino individual. Cabe ressaltar que o ensino coletivo não deve ser uma cópia do ensino individual, apenas direcionado a mais pessoas ao mesmo tempo. Uma das características do ensino coletivo é que todos os estudantes devem estar ativos o tempo todo durante a aula. Para tanto, a atuação do professor também deve ser diferenciada, capaz de agregar todos os estudantes em função dos objetivos propostos. As práticas dos jogos de improvisação oferecidas aqui só são possíveis dentro desse contexto, tendo em vista que são direcionadas para a aprendizagem coletiva do instrumento em associação com os objetivos e concepções desse processo.',
    style: ['paragraph'],
  },
  {
    text: 'Atividades práticas:',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'O educador, pesquisador e compositor François Delalande, que integra o grupo francês GRM fundado por Pierre Schaeffer em 1951, através de intensas pesquisas com crianças, aponta que, comumente, ao começar a estudar um instrumento musical, os estudantes possuem uma postura semelhante à do compositor de música concreta. Ele aponta, por exemplo, a necessidade exploratória com fins expressivos dos corpos sonoros, no nosso caso, do violoncelo. Enquanto professores, podemos observar essa necessidade na tendência natural do estudante em percutir, raspar, friccionar e produzir diferentes ações com resultantes sonoras diversas. Podemos observar também que as crianças e adolescentes, na fase inicial do estudo do violoncelo, não possuem preconceitos estéticos como os que são apresentados por estudantes ou músicos mais avançados tecnicamente. Os estudantes iniciantes aceitam o violoncelo como uma possibilidade infinita de produção de diferentes músicas, com suas multiplicidades estéticas. Tal observação nos leva a concluir que as dificuldades de compreensão da música contemporânea por músicos profissionais é uma dificuldade colocada pela repetição sistemática de determinados estilos musicais, geralmente os pertencentes a música europeia de concerto dos séculos XVIII e XIX.',
    style: ['paragraph'],
  },
  {
    text:
      'Sendo assim, pode-se concluir que uma das maneiras de começar a ensinar o repertório de música contemporânea e os jogos de improvisação é permitindo que o estudante exerça sua curiosidade natural em explorar os sons do entorno, entre eles, os sons que podem ser produzidos pelo violoncelo. Ao fazermos isso, podemos utilizar algumas ideias provenientes de alguns compositores de música contemporânea, como a narratividade, a paisagem sonora e a mimese. A mimese é um recurso utilizado por diferentes linguagens artísticas, entre elas, a música. Em música, a mimese consiste basicamente na imitação dos fenômenos ambientais ou psicológicos por meio das qualidades do som e da construção de narrativas musicais.',
    style: ['paragraph'],
  },
  {
    text:
      'Durante a exploração do violoncelo, a mimese também pode ser usada como recurso pedagógico. Os diferentes sons produzidos pelo violoncelo podem ser relacionados, em conjunto com os estudantes, com conteúdos psicológicos e ambientais. Tal abordagem proporciona aos estudantes a compreensão de que os sons produzidos por meio das técnicas estendidas, ou seja, maneiras não convencionais de abordar o instrumento, não são apenas ruídos, e sim parte importante do leque expressivo musical. Assim, os estudantes passam a produzir conteúdos musicais cada vez subjetivos, englobando tanto as técnicas convencionais quanto as técnicas estendidas. Dessa maneira, tornam-se capazes de expressar seus pensamentos, sentimentos e emoções por meio de ideias musicais.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Jogos de improvisação coletiva:',
    style: ['title1'],
  },
  {
    text: 'Descrição do Jogo 1',
    style: ['paragraph', 'bold', 'anchor'],
  },
  {
    text: 'Pergunta e Resposta com cordas soltas em pizzicato',
    style: ['title2'],
  },
  {
    text: 'Autoria: Marta Brietzke',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Objetivos:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Propiciar aos estudantes a consciência da sua individualidade e seu papel dentro do coletivo; estabelecer as ideias de narrativa musical, de perguntas e respostas, enfatizando o uso das quatro cordas do violoncelo, do pizzicato, de diferentes ritmos, métricas, timbres e dinâmicas.',
    style: ['paragraph'],
  },
  {
    text: 'Metodologia e aplicação:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Se inicia o jogo explicando aos estudantes o que poderia ser uma pergunta e uma resposta dentro de uma “narrativa” musical. Podemos dar um exemplo com nosso próprio instrumento, utilizando apenas as cordas soltas. Nesse momento, uma boa estratégia para que os estudantes compreendam os conceitos de pergunta e resposta é que utilizemos variações de dinâmica ou ritmo.',
    style: ['paragraph'],
  },
  {
    text:
      'Em seguida, propomos que cada um dos estudantes elabore uma resposta musical a uma pergunta que será feita por nós. O professor executa uma pergunta e o primeiro estudante executa uma resposta. Em seguida, o professor executa outra pergunta e o segundo estudante executa uma resposta e assim sucessivamente, até que todos os estudantes tenham participado do jogo. Podemos fazer quantas rodadas acharmos necessário, dependendo de cada turma ou grupo de estudantes. As perguntas podem englobar diferentes dinâmicas, ritmos e métricas, a fim de que os estudantes sejam estimulados de diferentes maneiras.',
    style: ['paragraph'],
  },
  {
    text:
      'Logo após, propomos que os estudantes se distribuam em duplas e que escolham quem vai fazer a pergunta e quem vai fazer a resposta. Cada dupla se dispõe em um local da sala e é importante que os estudantes tenham experiência em ambos os papéis. A ideia é que, após esse momento, os estudantes possam “apresentar”, em duplas, para os demais colegas uma série de perguntas e respostas elaboradas por eles.',
    style: ['paragraph'],
  },
  {
    text:
      'É importante que possibilitemos uma certa autonomia aos estudantes. É interessante que deixemos a sua escolha definir quantas perguntas e respostas querem apresentar aos colegas, quem inicia perguntando, que sinal vão combinar para o início e o final das sessões de perguntas e respostas. Com frequência, vamos observar um aumento na complexidade das perguntas e respostas feitas pelos estudantes em relação àquelas elaboradas no início do jogo.',
    style: ['paragraph'],
  },
  {
    text: 'Fonte: elaborado pela autora.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Descrição do Jogo 2',
    style: ['paragraph', 'bold', 'anchor'],
  },
  {
    text: 'Sinal Verde X Sinal Vermelho',
    style: ['title2'],
  },
  {
    text: 'Autoria: Maria Teresa Alencar de Brito',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Adaptação: Marta Brietzke',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Objetivos:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Trabalhar as diferenças entre som e silêncio, bem como sua importância e papel dentro da construção musical; aprofundar a importância da coletividade dentro do processo musical; estabelecer a ideia de diálogo musical.',
    style: ['paragraph'],
  },
  {
    text: 'Metodologia e aplicação:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Antes da sua realização, podemos propor aos estudantes que explorem as diferentes sonoridades dos seus violoncelos. Uma das maneiras de realizar essa prática é por meio da imitação: propomos um som e pedimos que os estudantes repitam, em conjunto ou individualmente, esse mesmo som. É interessante que possamos nomear as técnicas que já apresentam um nome definido pela literatura, como por exemplo, con legno, sul ponticelo, pizzicato Bartók. É importante que abramos espaço para que os estudantes descubram seus próprios sons, destinando uma parte dessa exploração para que eles abordem sozinhos seus instrumentos. Podemos pedir para que cada um demonstre aos demais colegas um som que descobriu, a fim, novamente, de dar voz ao estudante, e, posteriormente, todos repetem aquele som.',
    style: ['paragraph'],
  },
  {
    text:
      'Podemos também escolher alguns desses sons e compartilhá-los com os estudantes, se considerarmos que o aprendizado de todos os sons no mesmo dia pode causar alguma dificuldade de assimilação. Posteriormente, nas próximas aulas, podemos introduzir mais alguns desses sons, a fim de aumentar o leque expressivo dos estudantes. Em alguns grupos de estudantes, que ainda não sabem segurar o arco, podemos oferecer esses mesmos sons, propondo que os estudantes segurem o arco “abraçando-o” no talão. Dessa maneira, os estudantes ficarão confortáveis e não vão adquirir vícios posturais. A maioria dos sons podem ser produzidos com a “pegada” do arco dessa maneira, possibilitando que os jogos sejam desenvolvidos em paralelo com a aquisição técnica dos estudantes.',
    style: ['paragraph'],
  },
  {
    text:
      'Após a exploração do instrumento, mostramos aos estudantes dois pequenos cartazes, um verde e um vermelho. Associamos esses cartazes às regras de trânsito, em que o verde significa seguir ou, então, tocar, e o vermelho significa parar ou não tocar. Podemos propor que os estudantes escolham, cada um, um dos sons inventariados anteriormente, ou então que produzam diferentes sons. Ao ser apresentado o sinal verde, os estudantes devem executar um som no seu violoncelo. Ao ser apresentado o sinal vermelho, os estudantes devem fazer uma pausa. Dessa maneira, estabelecemos a importância e a função do silêncio na perspectiva musical.',
    style: ['paragraph'],
  },
  {
    text:
      'É interessante proporcionar aos estudantes a experiência de ser o “maestro”, ou seja, a pessoa que vai escolher quando se faz som, quando se faz silêncio. Após algumas rodadas do jogo, podemos distribuir mais um sinal verde e um sinal vermelho, estabelecendo dois “maestros” e dividindo o grupo em dois. Cada grupo deve seguir as orientações do seu maestro específico, o que resultará em diálogos musicais entre os dois grupos e uma sonoridade mais complexa.',
    style: ['paragraph'],
  },
  {
    text:
      'Os maestros devem se comunicar entre si para definir o início e o fim da música, cabendo a nós, estabelecermos que essa comunicação deve ser não verbal. Devemos salientar nessa fase do jogo que é importante que, tantos os maestros quanto os executantes escutem as diferentes sonoridades produzidas pelo grupo e se tornem conscientes da “narrativa” musical que está sendo criada. Os maestros devem ser incentivados a criarem, junto com os sinais verde e vermelho, sinais de variação de dinâmicas, de articulação e de caráter. Por exemplo, abaixar o sinal pode indicar tocar mais piano, levantar o sinal pode significar tocar mais forte. Devemos estar atentos e estimular que o poder de escuta dos estudantes vá se aprofundando em cada rodada do jogo, evitando que ele se torne mecânico e repetitivo.',
    style: ['paragraph'],
  },
  {
    text:
      'Também é interessante nesse momento que mostremos a gravação de alguma peça musical que utilize técnicas estendidas, como por exemplo, a peça Pression de Helmut Lachenmann, disponível em várias versões no site youtube. Tal audição aproxima o trabalho realizado pelos estudantes com o trabalho realizado por outras pessoas, o que é importante para que os estudantes valorizem sua própria produção e as dos demais. Outra peça interessante são as improvisações por senhas executadas pelo grupo de violoncelistas argentinos _ARRE!_ Algumas dessas improvisações também estão disponíveis no site youtube e proporcionam ao estudante a escuta de diferentes sonoridades, sendo produzidas por grupo de violoncelos e, assim como em Lachenmann, aproximam o trabalho realizado pelos estudantes com o que vem sendo produzido pelos músicos da atualidade.',
    style: ['paragraph'],
  },
  {
    text: 'Fonte: Elaborado pela autora, com base nas propostas de Maria Teresa Alencar de Brito.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Descrição do Jogo 3',
    style: ['paragraph', 'bold', 'anchor'],
  },
  {
    text: 'A noite no Castelo',
    style: ['title2'],
  },
  {
    text: 'Autoria: Claudia Freixedas',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Objetivos:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Estabelecer uma relação entre o imaginário e o sonoro; reforçar a confiança entre pares; desenvolver o poder de escolha dentro da criação musical.',
    style: ['paragraph'],
  },
  {
    text: 'Metodologia e aplicação:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Nesse jogo contamos uma história imaginando um castelo mal-assombrado em meio a uma noite de tempestade. Estimulamos os estudantes a narrarem quais elementos estariam presentes nesse castelo, como por exemplo, teias de aranha, morcegos, fantasmas, bem como os elementos da natureza, como por exemplo, trovões, rajadas de vento, chuva. Nessa tempestade, um viajante se aproximará do castelo e tomará contato com essas diferentes manifestações.',
    style: ['paragraph'],
  },
  {
    text:
      'Distribuímos os estudantes em diferentes pontos da sala, de preferência com uma certa distância entre eles. Cada estudante escolherá o som que deseja executar ou pode ser estabelecido que os estudantes possam executar mais de um tipo de som, dependendo do que julgarem adequado ao contexto musical. Cada estudante representará um objeto do castelo, não sendo necessário que se nomeie cada um desses objetos e deixando a cargo da imaginação de cada um, dando possibilidades que associações subjetivas sejam feitas pelos estudantes.',
    style: ['paragraph'],
  },
  {
    text:
      'Um estudante escolhido pelo grupo será o viajante. Esse estudante ficará vendado com um lenço, simulando a escuridão do castelo. O objetivo é que o viajante caminhe pelo castelo sem bater em nenhum objeto. Para isso, quando o viajante se aproximar de um objeto, o estudante responsável pelo objeto deve produzir o som escolhido. Quando o viajante se afastar do objeto, o som vai diminuindo de intensidade e o som do objeto mais próximo ao viajante vai sendo acionado.',
    style: ['paragraph'],
  },
  {
    text:
      'À medida que realizamos as rodadas desse jogo, podemos acrescentar complexidades. Podemos sugerir que o viajante demore mais frente a um objeto cujo som deseja ouvir ou que volte para um som já ouvido e que deseja ouvir novamente. Assim, o estudante viajante se torna uma espécie de maestro e suas escolhas produzem determinada “narrativa” musical.',
    style: ['paragraph'],
  },
  {
    text:
      'É interessante que se faça uma gravação em áudio ou vídeo da improvisação e que, posteriormente, se escute essa gravação em conjunto e se discuta sobre o resultado. A audição da peça inteira proporciona a todos os participantes a ideia geral da proposta musical produzida. Algumas vezes, os estudantes envolvidos na execução podem perder a noção do todo musical e essa audição é fundamental para que os estudantes percebam que não estão sendo produzidos apenas ruídos desconexos e sim, um “caminho” musical.',
    style: ['paragraph'],
  },
  {
    text: 'Fonte: Elaborado pela autora, com base nas propostas de Claudia Freixedas.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Descrição do Jogo 4',
    style: ['paragraph', 'bold', 'anchor'],
  },
  {
    text: 'Assinatura Musical',
    style: ['title2'],
  },
  {
    text: 'Autoria: Wanderson Cruz',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Objetivos:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Possibilitar a experiência de criação a partir de células musicais pré-estabelecidas; proporcionar diferenças entre as polifonias e homofonias; incentivar o poder de escolha dentro da criação musical.',
    style: ['paragraph'],
  },
  {
    text: 'Metodologia e aplicação:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Iniciamos perguntando para os estudantes o que é uma assinatura. Logo após, relacionamos essa resposta com o que seria uma “assinatura musical”. Podemos dar um exemplo com nosso próprio instrumento, sendo interessante que utilizemos sons convencionais e sons provenientes das técnicas estendidas.',
    style: ['paragraph'],
  },
  {
    text:
      'Propomos, então, que cada um crie sua própria assinatura musical utilizando para isso os sons que desejar. Damos um tempo para que os estudantes façam essa pesquisa e escolham individualmente sua assinatura. Logo após, propomos que cada estudante execute a sua assinatura para os demais colegas do grupo, a fim de que todos possam conhecer todas as assinaturas. É interessante que peçamos aos estudantes que executem mais de uma vez a sua assinatura, para que possamos verificar se ele está mantendo sempre a mesma assinatura ou se a cada vez executa uma assinatura diferente. Nesse jogo, propomos que as assinaturas de cada estudante sejam sempre as mesmas.',
    style: ['paragraph'],
  },
  {
    text:
      'Após a apresentação dos estudantes, sugerimos a composição de uma peça utilizando as assinaturas musicais de cada um dos estudantes. Escolhemos um maestro para que organize a composição. O maestro executa sinais com as mãos e com o corpo indicando quando cada estudante deve tocar sua assinatura, com que dinâmica e quando deve parar de tocar. A ideia é que enquanto o maestro não der um sinal para parar de tocar, as assinaturas vão sendo executadas continuamente. Ao terminar sua assinatura, o estudante recomeça do princípio até que receba um sinal para parar.',
    style: ['paragraph'],
  },
  {
    text:
      'Devemos estimular os estudantes a trabalharem sua escuta e sua escolha artística frente ao material apresentado pelos colegas. Dessa forma, evitamos novamente que o jogo se torne mecânico e proporcionamos a construção de uma ideia musical consistente.',
    style: ['paragraph'],
  },
  {
    text:
      'É interessante, em todos os jogos, que o professor seja o maestro na primeira vez que o jogo está sendo executado, mas que, em seguida, sejam escolhidos diferentes estudantes para assumirem essa função. Assim, possibilitamos que todos os estudantes do grupo possam, em algum momento, participar como maestros de algum dos jogos de improvisação.',
    style: ['paragraph'],
  },
  {
    text: 'Fonte: Elaborado pela autora, com base nas propostas de Wanderson Cruz.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Descrição do Jogo 5',
    style: ['paragraph', 'bold', 'anchor'],
  },
  {
    text: 'Igual X Parecido X Diferente',
    style: ['title2'],
  },
  {
    text: 'Autoria: Violeta Gainza',
    style: ['paragraph', 'italic'],
  },

  {
    text: 'Adaptação: Marta Brietzke',
    style: ['paragraph', 'italic'],
  },

  {
    text: 'Objetivos:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Trabalhar as ideias de similaridade e diferença em música; proporcionar a criação a partir de um elemento dado previamente; trabalhar a ideia de frases ou narrativas musicais.',
    style: ['paragraph'],
  },
  {
    text: 'Metodologia e aplicação:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Apresentamos aos estudantes três pequenos cartazes. No primeiro cartaz, apresentamos o sinal matemático utilizado para igual, no segundo o sinal matemático utilizado para diferente e no terceiro cartaz podemos criar algum sinal que represente o parecido. Propomos aos estudantes que eles devem respeitar os sinais que serão oferecidos a eles. O primeiro estudante cria livremente uma frase musical. Em seguida, o professor apresenta um dos sinais ao segundo estudante, que deve repetir ou variar a frase de acordo com o sinal representado. O professor oferece, então, um novo sinal ao terceiro estudante, que agora deve repetir ou variar a frase apresentada pelo segundo estudante. Assim o jogo segue até que todos os estudantes tenham elaborado suas frases. Os sinais podem ser escolhidos aleatoriamente ou selecionados previamente pelo professor.',
    style: ['paragraph'],
  },
  {
    text:
      'Em seguida, propomos que um dos estudantes seja o maestro e faça as indicações dos cartazes aos seus colegas. Podemos acrescentar complexidades ao jogo propondo que o maestro, além de escolher o próximo cartaz que oferecerá aos colegas, escolha também, sempre de maneira não verbal, o estudante que executará a próxima variação da frase.',
    style: ['paragraph'],
  },
  {
    text: 'Fonte: Elaborado pela autora, com base nas propostas de Violeta Gainza.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Descrição do Jogo 6',
    style: ['paragraph', 'bold', 'anchor'],
  },
  {
    text: 'Composição com gravuras e escrita com notação própria',
    style: ['title2'],
  },
  {
    text: 'Autoria: Diversos autores',
    style: ['paragraph', 'italic'],
  },

  {
    text: 'Adaptação: Marta Brietzke',
    style: ['paragraph', 'italic'],
  },

  {
    text: 'Objetivos:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Aproximar os estudantes da ideia de composição; desenvolver uma simbologia própria que represente suas ideias musicais; fazer contato com diferentes maneiras de escrita e representação musical; chamar a atenção para as limitações existentes em qualquer tipo de escrita musical; aproximar compositores e intérpretes.',
    style: ['paragraph'],
  },
  {
    text: 'Metodologia e aplicação:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Para o jogo de composição com gravuras solicitamos na aula anterior que os estudantes tragam gravuras de revistas ou fotos pessoais. Porém, é interessante que o professor traga algumas gravuras selecionadas previamente, pois algumas vezes os estudantes esquecem de trazê-las e a atividade fica comprometida. Também é necessário que o professor traga cartazes de cartolina e jogos de lápis de cor. Também podemos acrescentar outros materiais, conforme nossa disponibilidade, como por exemplo, palitos de dente, fitas coloridas, cordões de espessuras diversas, pedrinhas, etc.',
    style: ['paragraph'],
  },
  {
    text:
      'Começamos o jogo dividindo a turma em grupos. Cada grupo irá apresentar suas gravuras e fotos para os demais colegas. O professor poderá distribuir mais gravuras aos estudantes. Propomos, então, que os estudantes escolham uma ou mais gravuras ou fotos, quantas desejarem, para que contem uma história musical. Podemos dar um exemplo com nosso próprio violoncelo escolhendo uma das gravuras. Devemos ressaltar que a história deve ter um enredo, um início, meio e fim e que os estudantes devem discutir e elaborar em conjunto esse enredo, de acordo com a(s) gravura(s) que escolherem.',
    style: ['paragraph'],
  },
  {
    text:
      'Após a elaboração do enredo, estimulamos que os estudantes produzam com os seus violoncelos conteúdos musicais que representem a história criada por eles.  A história poderá ser contada em partes, ou mesmo simultaneamente, dependendo das escolhas feitas pelos estudantes. A seleção desses conteúdos deve ser feita em conjunto pelos grupos e podemos dar a eles quanto tempo acharmos necessário para que pesquisem e selecionem os sons desejados.',
    style: ['paragraph'],
  },
  {
    text:
      'Num terceiro momento do jogo, distribuímos os cartazes, os lápis coloridos e os demais materiais e propomos que os estudantes criem uma maneira de “escrever” a música inventada por eles. Essa escrita pode utilizar desenhos, cores, símbolos, palavras, dependendo do que cada grupo achar conveniente. Podemos sugerir que escolham um título para sua peça, que coloquem seus nomes como compositores ou podemos nem mencionar tais aspectos, dando liberdade para que cada grupo determine o que julgar necessário para a compreensão da peça.',
    style: ['paragraph'],
  },
  {
    text:
      'Quando os estudantes terminarem sua escrita, solicitamos que, em conjunto, utilizando ou não a partitura, ensaiem a peça criada por eles. Devemos dar autonomia para que eles estabeleçam entre si sinais para o início e fim da música, sinais de dinâmica e outras informações que sintam necessidade. Após alguns ensaios, propomos um momento de apresentação das peças para os colegas do outro grupo.',
    style: ['paragraph'],
  },
  {
    text:
      'Podemos sugerir que os estudantes contem sua história e depois executem a peça ou que executem a peça e depois contem sua história, ou apenas que mostrem as gravuras escolhidas por eles para a criação das suas peças, dependendo do que julgarmos interessante no momento. É importante que nesse momento também proporcionemos autonomia aos estudantes na sua organização e apresentação aos demais colegas.',
    style: ['paragraph'],
  },
  {
    text: 'Fonte: Elaborado pela autora.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Descrição do Jogo 7',
    style: ['paragraph', 'bold', 'anchor'],
  },
  {
    text: 'Improvisação com ostinato',
    style: ['title2'],
  },
  {
    text: 'Autoria: Vários autores',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Adaptação: Marta Brietzke',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Objetivos:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Trabalhar a noção de solo e tutti; trabalhar a ideia de ostinato; trabalhar o conceito de forma musical.',
    style: ['paragraph'],
  },
  {
    text: 'Metodologia e aplicação:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Iniciamos esse jogo de improvisação explicando aos estudantes o que é um ostinato. Logo após, propomos algum ostinato rítmico a ser executado por todos os estudantes com a corda solta ré, em pizzicato. Esse ostinato deve ser simples, como por exemplo, uma semínima seguida de duas colcheias.',
    style: ['paragraph'],
  },
  {
    text:
      'Propomos, então, aos estudantes que o grupo se divida em orquestra e solista. O grupo que representará a orquestra executará o ritmo ostinato com corda solta ré, enquanto o estudante escolhido para ser solista executará diferentes frases, englobando os conhecimentos musicais e técnicos já aprendidos por eles. Não é necessário, nesse momento, que se pense em harmonia ou condução vocal, pois a improvisação não necessita obedecer aos padrões estéticos do tonalismo. O objetivo é que os estudantes possam utilizar livremente seus conhecimentos musicais e organizar suas ideias, tendo como ponto de partida um ritmo em ostinato.',
    style: ['paragraph'],
  },
  {
    text:
      'Podemos organizar a improvisação de diferentes maneiras, como por exemplo, estabelecendo que vamos executar duas vezes o ritmo em ostinato após o término de cada solo, para que o próximo executante identifique a sua hora de entrar como solista na execução. Também podemos organizar a improvisação na forma rondó, propondo que a parte A seja algum número específico de vezes da repetição do ostinato ou algum tema criado em conjunto pelo grupo, a ser executado pelo solista antes da sua livre improvisação, etc. Organizamos e acrescentamos complexidade ao jogo no decorrer das jogadas, que podem ser intercaladas com sessões de audição coletiva da gravação das improvisações.',
    style: ['paragraph'],
  },
  {
    text: 'Fonte: Elaborado pela autora.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Descrição do Jogo 8',
    style: ['paragraph', 'bold', 'anchor'],
  },
  {
    text: 'A floresta encantada',
    style: ['title2'],
  },
  {
    text: 'Autoria: Claudia Freixedas',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Objetivos:',
    style: ['paragraph', 'bold'],
  },
  {
    text: 'Trabalhar o diálogo musical; trabalhar a ideia de polifonia.',
    style: ['paragraph'],
  },
  {
    text: 'Metodologia e aplicação:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Consiste em uma variação do jogo A noite no Castelo, com um acréscimo de complexidade. Nesse caso, também criamos uma história na qual dois exploradores chegam a uma floresta encantada. Nessa floresta, cada árvore emite um som diferente. Quando os exploradores se aproximam das árvores, elas emitem o seu som. Podemos realizar esse jogo com os olhos abertos ou vendados, de forma semelhante à do jogo A noite no Castelo e as árvores podem emitir um único som ou diferentes sons conforme o contexto musical. É interessante, no entanto, propormos algumas diferenças entre este jogo e o jogo anterior.',
    style: ['paragraph'],
  },
  {
    text:
      'Nesse jogo, uma das complexidades a serem apresentadas aos estudantes é que mais de um explorador entra na floresta ao mesmo tempo. Tal característica proporcionará a existência de um diálogo a ser “composto” pelos exploradores, que também atuarão como maestros.',
    style: ['paragraph'],
  },
  {
    text: 'Fonte: Elaborado pela autora, com base nas propostas de Claudia Freixedas.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Descrição do Jogo 9',
    style: ['paragraph', 'bold', 'anchor'],
  },
  {
    text: 'Passeio no zoológico',
    style: ['title2'],
  },
  {
    text: 'Autoria: Violeta Gainza',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Objetivos:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Trabalhar diferentes possibilidades musicais de uma mesma sonoridade; trabalhar a ideia de narrativa musical.',
    style: ['paragraph'],
  },
  {
    text: 'Metodologia e aplicação:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Nesse jogo, também criamos, em conjunto com os estudantes, uma história de um visitante em um zoológico. O visitante passeia pelo zoológico e observa os diferentes animais. Cada estudante escolherá um animal para representar com seu violoncelo. O visitante escolherá qual animal quer visitar se posicionando na frente de cada um dos colegas que estará representando-o.',
    style: ['paragraph'],
  },
  {
    text:
      'Nesse jogo, podemos acrescentar a interação do visitante com os animais. Conforme essa interação ocorra, o animal pode se manifestar com diferentes caracteres musicais, utilizando diferentes dinâmicas, articulações, ritmos, nuances timbrísticas ou organização dos conteúdos em forma de frases musicais.',
    style: ['paragraph'],
  },
  {
    text:
      'Assim, como citado anteriormente, podemos gravar as improvisações resultantes, aumentando o poder de escuta e análise dos estudantes, possibilitando que nas próximas rodadas dos jogos as interações musicais sejam, cada vez mais, provenientes da escolha artística dos estudantes. Devemos sempre evitar que a execução dos jogos se torne uma atividade mecânica e desprovida de análise crítica, pois, nesse caso, perdemos uma importante estratégia de desenvolvimento musical dos estudantes.',
    style: ['paragraph'],
  },
  {
    text: 'Fonte: Elaborado pela autora, com base nas propostas de Violeta Gainza.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Descrição do Jogo 10',
    style: ['paragraph', 'bold', 'anchor'],
  },
  {
    text: 'Os pássaros e o caçador',
    style: ['title2'],
  },
  {
    text: 'Autoria: Claudia Freixedas',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Adaptação: Marta Brietzke',
    style: ['paragraph', 'italic'],
  },
  {
    text: 'Objetivos:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Trabalhar a liberdade e as diferentes opções para o início, o desenvolvimento e o final da “peça” musical; trabalhar questões ligadas à ecologia e à ecologia acústica; trabalhar os diálogos, as polifonias e a noção de forma musical.',
    style: ['paragraph'],
  },
  {
    text: 'Metodologia e aplicação:',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'Nesse jogo, perguntamos aos estudantes quais sons de pássaros eles conhecem. Podemos inventariar, coletivamente, esses sons ou nos propormos a investigar em nossas casas e trazermos os resultados de nossas investigações aos demais colegas. Também podemos trazer um catálogo da gravação de sons de pássaros que podemos obter em sites da internet. Dessa forma, escolhemos alguns pássaros que desejamos imitar e buscamos sonoridades semelhantes em nossos violoncelos.',
    style: ['paragraph'],
  },
  {
    text:
      'Após a escolha dos sons dos pássaros, cada estudante se torna responsável pela emissão de um desses sons, representando uma espécie de pássaros. Em seguida, escolhemos em conjunto um som representativo que imite o som produzido pelo caçador. Esse som pode ser o som de um rifle disparando, da caminhada do caçador pela mata ou do que a imaginação dos estudantes determinar.',
    style: ['paragraph'],
  },
  {
    text:
      'Propomos, então, que na mata onde se encontram os pássaros, cada um deles atue de forma a dialogar com os demais pássaros, criando conscientemente um conteúdo sonoro. Um estudante será responsável por executar o som do caçador. Todos os pássaros, ao ouvirem o som do caçador, calam-se por um momento. Em seguida, não havendo mais perigo, os pássaros pouco a pouco voltam a cantar, novamente estabelecendo um diálogo com os demais pássaros da mata.',
    style: ['paragraph'],
  },
  {
    text:
      'O caçador pode intervir na mata o número de vezes que desejar e com a frequência que desejar. Também devemos dar autonomia para que o próprio grupo sinta o tempo necessário de silêncio após a intervenção do caçador, o momento de iniciar a improvisação e o momento de finalizá-la. Dessa maneira, ampliamos a percepção do grupo em relação à atuação e à participação de cada um no todo musical.',
    style: ['paragraph'],
  },
  {
    text: 'Fonte: Elaborado pela autora, com base nas propostas de Claudia Freixedas.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Sugestão de repertório:',
    style: ['title1', 'anchor'],
  },
  {
    text:
      'A fim de contextualizarmos o trabalho com os jogos de improvisação dentro das poéticas da música contemporânea e oferecermos subsídios aos estudantes, podemos apresentar, em diferentes momentos, peças do repertório dos séculos XX e XXI, compostas para violoncelo. O objetivo da audição de tais peças é que os estudantes possam identificar elementos comuns dessas peças com as suas próprias criações e assim valorizem mais o seu trabalho e o trabalho dos compositores apresentados.',
    style: ['paragraph'],
  },
  {
    text: 'Relação de peças do repertório contemporâneo para violoncelo',
    style: ['paragraph', 'bold'],
  },
  {
    text: 'Lachenmann, Helmut - Pression para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'ARRE! - Improvisações por senhas para grupo de violoncelos',
    style: ['itemList'],
  },
  {
    text: 'Penderecki, Kristof - Capriccio per Siegfried Palm, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Berio, Luciano - Sequenza XIV, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Boulez, Piérre - Messagesquisse, para violoncelo solo e seis violoncelos',
    style: ['itemList'],
  },
  {
    text: 'Saraaiaho, Kaija - Sept Papillons, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Ligeti, Györgi - Sonata, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Romitelli, Fausto - Professor Bad Trip- lesson II- cadência para violoncelo',
    style: ['itemList'],
  },
  {
    text: 'Furrer, Beat - Solo für cello, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Scelsi, Giancinto - Trilogia , para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Crumb, George - Sonata para Violoncelo, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Kagel, Maurício - Match, para dois violoncelos e percussão',
    style: ['itemList'],
  },
  {
    text: 'Sciarrino, Salvatore - Variazoni, para violoncelo e orquestra',
    style: ['itemList'],
  },
  {
    text: 'Saunders, Rebecca - Solitude, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Rihm, Wolfgang - Von Weit, para violoncelo e piano',
    style: ['itemList'],
  },
  {
    text: 'Ginastera, Alberto - Puneña, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Gras, Germán - Solo para Marta, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Kiefer, Bruno - Errância, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Santoro, Claúdio - Fantasia Sulamérica, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Nobre, Marlos - Desafio, para violoncelo e orquestra',
    style: ['itemList'],
  },
  {
    text: 'Lima, Rodrigo - Circuncello, para violoncelo e orquestra',
    style: ['itemList'],
  },
  {
    text: 'Ferraz, Sílvio - Lamento quase mudo, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Angelo, Bruno - Traçado íntimo e hesitante, para violoncelo solo',
    style: ['itemList'],
  },
  {
    text: 'Fonte: Elaborado pela autora.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Para saber mais:',
    style: ['title2', 'anchor'],
  },
  {
    text: 'Relação de livros e publicações sobre os temas tratados',
    style: ['paragraph', 'bold'],
  },
  {
    text:
      'ALONSO, Chefa. Improvisación libre: la composición en movimiento. Baiona: Editorial Dos acordes S. L., 2007.',
    style: ['itemList'],
  },
  {
    text:
      'DELALANDE, François. La música es un juego de niños. Buenos Aires: Ricordi Americana, 2001.',
    style: ['itemList'],
  },
  {
    text:
      'COSTA, Rogério. Música errante: o jogo da improvisação livre. São Paulo: Perspectiva: Fapesp, 2016.',
    style: ['itemList'],
  },
  {
    text:
      'GAINZA, Violeta. La improvisación musical. Buenos Aires: Melos de Ricordi Americana, 2009.',
    style: ['itemList'],
  },
  {
    text:
      'KISHIMOTO, Tizuko Morchida. O jogo e a educação infantil. São Paulo: Cengage Learning, 2013.',
    style: ['itemList'],
  },
  {
    text:
      'MATTHEWS, Wade. Improvisando: La libre creación musical. Madrid: Turner Publicaciones S. L., 2012.',
    style: ['itemList'],
  },
  {
    text:
      'TOURINHO, Cristina, TOURINHO, Cristina. Ensino coletivo de instrumentos musicais: crenças, mitos, princípios e um pouco de história. In: XVI Encontro Nacional da ABEM, 2007. Mato Grosso do Sul.',
    style: ['itemList'],
  },
  {
    text: 'Fonte: Elaborado pela autora.',
    style: ['paragraph', 'citation'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: 'Referência:',
    style: ['title1'],
  },
  {
    text: 'BRIETZKE, Marta Macedo. ',
    titleStrong:
      'A música contemporânea na iniciação coletiva ao violoncelo: uma pesquisa-ação com jogos de improvisação em três instituições de ensino no estado de São Paulo. ',
    rest:
      '2018. 159 f. Dissertação (Mestrado) - Escola de Comunicações e Artes - USP, São Paulo, 2018.',
    style: ['bibliography'],
  },
]

export default textData
